import { wrapWithDevConnectionState } from './wrap-with-dev-connection-state';
import { mapValues } from 'lodash';
export function withDevTools(api, getDevState) {
    return mapValues(api, (fn) => wrapWithDevConnectionState(fn, getDevState));
}
//# sourceMappingURL=with-dev-tools.js.map